import { Store } from "vuex";
import { namespace as appsNamespace } from "../modules/apps/apps";
import { App } from "../../types/app";
export class AppsStore {
    private store: Store<any>;
    constructor(store: Store<any>) {
        this.store = store;
    }
    /** Gets the apps */
    public get apps(): App[] {
        return this.store.getters[`${appsNamespace}/apps`];
    }

    public async loadApps(): Promise<App[]> {
        return this.store.dispatch(`${appsNamespace}/loadApps`);
    }
}
